module.exports = __webpack_public_path__ + "img/WDBC-Logo-125x96.25371688.png";